import React from 'react';
import { Heart, Github, Twitter, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>🏥 E-Medical</h3>
            <p>Your personal health companion</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4>Features</h4>
              <ul>
                <li><a href="/">Dashboard</a></li>
                <li><a href="/medications">Medications</a></li>
                <li><a href="/appointments">Appointments</a></li>
                <li><a href="/health-tracker">Health Tracker</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><a href="/settings">Settings</a></li>
                <li><a href="#help">Help Center</a></li>
                <li><a href="#privacy">Privacy Policy</a></li>
                <li><a href="#terms">Terms of Service</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Connect</h4>
              <div className="social-links">
                <a href="#github" className="social-link">
                  <Github size={20} />
                </a>
                <a href="#twitter" className="social-link">
                  <Twitter size={20} />
                </a>
                <a href="#linkedin" className="social-link">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2024 E-Medical Reminder App. All rights reserved.</p>
          </div>
          
          <div className="footer-team">
            <p>
              Built with <Heart size={16} className="heart-icon" /> by 
              <span className="team-name"> Hackathon Boys AEdG</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 